/**
 * AxonPage
 * DGR Data Entry for AxonMetric Site
 */

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { AxonRouter } from './forms/sites/Axon/AxonRouter';
import './forms/styles/EntryPage.css';

type FormType = "Daily Report" | "Weather" | "Inverters" | "Breakdowns" | "Plant Meters" | "";

const axonPage: React.FC = () => {
  const { site } = useParams<{ site: string }>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user, logout } = useAuth();

  // Reset internal sidebar width CSS variable to 0px so only MainSidebar controls the layout
  useEffect(() => {
    document.documentElement.style.setProperty('--sidebar-width', '0px');
    return () => {
      document.documentElement.style.removeProperty('--sidebar-width');
    };
  }, []);

  // Get storage key for active form (site-specific)
  const activeFormStorageKey = `axon_active_form_${site || 'default'}`;

  // Initialize activeForm from localStorage or query parameter or default to "Daily Report"
  const getInitialActiveForm = (): FormType => {
    // First check for query parameter
    const formParam = searchParams.get('form');
    if (formParam && ["Daily Report", "Weather", "Inverters", "Breakdowns", "Plant Meters"].includes(formParam)) {
      return formParam as FormType;
    }

    // Then check localStorage
    try {
      const saved = localStorage.getItem(activeFormStorageKey);
      if (saved && ["Daily Report", "Weather", "Inverters", "Breakdowns", "Plant Meters"].includes(saved)) {
        return saved as FormType;
      }
    } catch (error) {
    }
    return "Daily Report";
  };

  const [activeForm, setActiveForm] = useState<FormType>(getInitialActiveForm);

  // Sync activeForm with URL query parameter
  useEffect(() => {
    const formParam = searchParams.get('form');
    if (formParam && ["Daily Report", "Weather", "Inverters", "Breakdowns", "Plant Meters"].includes(formParam)) {
      if (formParam !== activeForm) {
        setActiveForm(formParam as FormType);
      }
    }
  }, [searchParams]);

  // Save activeForm to localStorage whenever it changes
  useEffect(() => {
    try {
      localStorage.setItem(activeFormStorageKey, activeForm);
    } catch (error) {
    }
  }, [activeForm, activeFormStorageKey]);

  return (
    <div className="entry-page relative w-full h-screen overflow-hidden flex flex-col pt-16">
      {/* Content Wrapper - Fills full space next to MainSidebar */}
      <div className="flex-1 w-full h-full overflow-hidden relative flex flex-col">
        <AxonRouter activeForm={activeForm} site={site} />
      </div>
    </div>
  );
};

export default axonPage;


